import { render, staticRenderFns } from "./FlightItemApp.vue?vue&type=template&id=5d10203e&scoped=true"
import script from "./FlightItemApp.vue?vue&type=script&lang=js"
export * from "./FlightItemApp.vue?vue&type=script&lang=js"
import style0 from "./FlightItemApp.vue?vue&type=style&index=0&id=5d10203e&prod&scoped=true&lang=css"
import style1 from "./FlightItemApp.vue?vue&type=style&index=1&id=5d10203e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d10203e",
  null
  
)

export default component.exports